import { Component, OnInit, ViewChild } from "@angular/core";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBarConfig, MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { RequestModel } from "../../Shared/Models/app.MasterRequestModel";
import { constantUrl } from "../../Shared/constantUrl";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { Router } from "@angular/router";
import { LosService } from "../../_LOS/services/los.service";
import * as moment from "moment";
import { LmsService } from "../../_Lms/services/lms.service";
declare var $: any;
import { DialogService } from "../../Shared/dialog.service";

@Component({
    selector: "app-vehicle-category",
    templateUrl: "./vehicle-category.component.html",
    styleUrls: ["./vehicle-category.component.scss"],
    standalone: false
})
export class VehicleCategoryComponent implements OnInit {
  private data: any;
  private _MasterService;
  showSpinner: boolean = false;
  private _LmsService;
  RequestModel: RequestModel = new RequestModel();
  ReportingManagerRequestModel: RequestModel = new RequestModel();
  CopyEmployeeRequestModel: RequestModel = new RequestModel();
  EmployeeProcessForCopyRequestModel: RequestModel = new RequestModel();
  SaveEmployeeDataRequestModel: RequestModel = new RequestModel();
  SaveEmployeeProfileRequestModel: RequestModel = new RequestModel();
  EmpDeleteAssBranchRequestModel: RequestModel = new RequestModel();
  EmpDeleteAssProcessRequestModel: RequestModel = new RequestModel();

  loading: boolean = false;
  CurrentDate: any = new Date();
  // register new role
  EmployeeId: any = 0;
  SelectRoleId: any = "";
  FirstName: any = "";
  LastName: any = "";
  SelectGender: any = "";
  DateOfBirth: any = "";
  PresentAddress: any = "";
  PermanentAddress: any = "";
  PhoneNo: any = "";
  AlternetPhoneNo: any = "";
  EnterEmail: any = "";
  AadharNo: any = "";
  EmployeeLoginId: any = "";
  EmployeePassword: any = "";
  EmpManagerId: any = "";
  UploadImageBase64: any = "";
  UploadImageName: string = "";
  profilePicture: string = "";
  // save data array
  SelectedLoanProcessData: any = [];
  SelectedBranchesData: any = [];
  // bind data
  BranchesList: any = [];
  LoanProcessList: any = [];
  EmployeeDetailData: any = {};
  RolesDropdownData: any = [];
  ReportingManagerDropdown: any;
  // copy employee
  CopyEmployeeDropdown: any = [];
  CopyEmployeeId: any = "";
  isShowCopyEmployee: boolean = false;
  applicationId: any = 95;
  dataCustomerSource: any;

  SelectManufacture: any = "";
  SelectVehicleCategory: any = "";
  ManufactureData: any = [];
  saveBtn: boolean = true;
  updateBtn: boolean = false;
  Id: number;
  VehicleCategoryTypeData: any = [];
  Vehicle_Category_Type: any = "";

  JsonData: any[] = [];

  displayedCustomerColumns: string[] = ["Number", "Vehicle Category","Vehicle Category Type", "Action"];

  constructor(
    private _Route: Router,
    private dataSharingService: DataSharingService,
    public snackBar: MatSnackBar,
    private MasterService: MasterService,
    private losService: LosService,
    private LmsService: LmsService,
    private dialog: DialogService
  ) {
    this._MasterService = MasterService;
    this._LmsService = LmsService;
    this.data = JSON.parse(sessionStorage.getItem("currentUser"));
  }

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  ngOnInit() {
    this.dataSharingService.HeaderTitle.next("Vehicle Category Master");
    // this._MasterService.GetRoleForDropdown().subscribe((result) => {
    //   this.RolesDropdownData = JSON.parse(JSON.stringify(result));
    // });

    this.LMS_GetVehicleMaster();
    this.LMS_GetAssetInfoMaster();
    this.Get_VehicleCategory_Type();
  }

  //getEmployeeData() {
  //  this.BranchesList = [];
  //  this.LoanProcessList = [];
  //  this.EmployeeId = sessionStorage.getItem('getEmployeeID');
  //  this.RequestModel.EmpId = parseInt(this.EmployeeId);
  //  this._MasterService.GetEmployeeDetails(this.RequestModel).subscribe((result) => {
  //    this.EmployeeDetailData = result;
  //    if (this.EmployeeDetailData.Item1[0]) {
  //      this.SelectRoleId = this.EmployeeDetailData.Item1[0].Emp_RoleId;
  //      this.onChangeRoles();
  //      this.FirstName = this.EmployeeDetailData.Item1[0].Emp_FirstName;
  //      this.LastName = this.EmployeeDetailData.Item1[0].Emp_LastName;
  //      this.SelectGender = this.EmployeeDetailData.Item1[0].Emp_Gender;
  //      this.DateOfBirth = new Date(moment(this.EmployeeDetailData.Item1[0].Emp_DOB).format('MM/DD/YYYY'));
  //      this.PresentAddress = this.EmployeeDetailData.Item1[0].Emp_PresentAddress;
  //      this.PermanentAddress = this.EmployeeDetailData.Item1[0].Emp_PermanentAddress;
  //      this.PhoneNo = this.EmployeeDetailData.Item1[0].Emp_PhoneNo;
  //      this.AlternetPhoneNo = this.EmployeeDetailData.Item1[0].Emp_PhoneNo1;
  //      this.EnterEmail = this.EmployeeDetailData.Item1[0].Emp_Email;
  //      this.AadharNo = this.EmployeeDetailData.Item1[0].Emp_AadharNo;
  //      this.EmployeeLoginId = this.EmployeeDetailData.Item1[0].Emp_LoginId;
  //      this.EmployeePassword = this.EmployeeDetailData.Item1[0].Emp_Password;
  //      this.EmpManagerId = this.EmployeeDetailData.Item1[0].Emp_ManagerId;
  //      this.UploadImageName = this.EmployeeDetailData.Item1[0].Emp_Image;
  //      this.UploadImageBase64 = this.EmployeeDetailData.Item1[0].Emp_Image != '' ? constantUrl.apiProfilePicUrl + this.EmployeeDetailData.Item1[0].Emp_Image : '';
  //    }
  //    this.BranchesList = this.EmployeeDetailData.Item2;
  //    this.BranchesList.map((item) => {
  //      item.isActiveSelect = item.BranchAlradyAssigned;
  //      item.isDisable = item.BranchAlradyAssigned;
  //    });
  //    this.LoanProcessList = this.EmployeeDetailData.Item3;
  //    this.LoanProcessList.map((item) => {
  //      item.isActiveSelect = item.ProcessAlradyAssigned;
  //      item.isDisable = item.ProcessAlradyAssigned;
  //    });
  //  });
  //}
  AddNewVehicleCategory(){
     $("#VehicleCategoryMaster").modal("show");
    $("#VehicleCategoryMaster").css("z-index", "1050");
  }
  onclose(){
    $("#VehicleCategoryMaster").modal("hide");
    this.Vehicle_Category_Type = "";
    this.SelectVehicleCategory = "";


  }

  onChangeRoles() {
    this.ReportingManagerDropdown = [];
    this.EmpManagerId = "";
    this.CopyEmployeeDropdown = [];
    this.CopyEmployeeId = "";
    if (this.SelectRoleId != "") {
      this.ReportingManagerRequestModel.EmployeeRole = parseInt(
        this.SelectRoleId
      );
      this._MasterService
        .ReportingManagerForDropdown(this.ReportingManagerRequestModel)
        .subscribe((result) => {
          this.ReportingManagerDropdown = JSON.parse(JSON.stringify(result));
        });
      if (this.EmployeeId == 0) {
        this.CopyEmployeeRequestModel.EmpRoleId = parseInt(this.SelectRoleId);
        this._MasterService
          .LOSGetEmployeeForCopyDropdown(this.CopyEmployeeRequestModel)
          .subscribe((result) => {
            this.CopyEmployeeDropdown = JSON.parse(JSON.stringify(result));
          });
      }
    }
    if (this.EmployeeId == 0) {
      this.isShowCopyEmployee = false;
      this.BranchesList.map((item) => {
        item.isActiveSelect = false;
        item.isDisable = false;
        item.BranchAlradyAssigned = false;
      });
      this.LoanProcessList.map((item) => {
        item.isActiveSelect = false;
        item.isDisable = false;
        item.ProcessAlradyAssigned = false;
      });
    }
  }

  LMS_GetAssetInfoMaster() {
    this.showSpinner = true;
    this._LmsService.Get_Lms_AssetInfo().subscribe((response) => {
      this.ManufactureData = response;
    });
  }

  LMS_GetVehicleMaster() {
    this._LmsService.Get_Lms_VehicleMaster().subscribe((response) => {
      console.log(response);
      this.dataCustomerSource = new MatTableDataSource(response);
      this.JsonData = JSON.parse(JSON.stringify(response));
    });
  }
  
  Get_VehicleCategory_Type() {
    this._MasterService.Get_VehicleCategory_Type().subscribe((response) => {
      console.log(response);
      this.VehicleCategoryTypeData = response;
      // this.dataCustomerSource = new MatTableDataSource(response);
      // this.JsonData = JSON.parse(JSON.stringify(response));
    });
  }

  exportexcelNew(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById(
      "export_vehicle_category"
    ) as HTMLTableElement;
    const worksheetName = "VEHICLE CATEGORY"; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }

  onSaveVehicleCatData() {
    let saveEmployeeDetail = {
      Int_Id: 0,
      Vehicle_Category: this.SelectVehicleCategory,
      IsActive: 1,
      Vehicle_Category_Type: this.Vehicle_Category_Type
    };
    this._LmsService
      .Save_Lms_VehicleCategoryMaster(saveEmployeeDetail)
      .subscribe((response) => {
        if (response[0].CODE == 0) {
          this.SelectVehicleCategory = "";
          this.LMS_GetVehicleMaster();
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
          this.onclose();
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
        }
      });
  }

  removeVehicleCat(data: any) {
    this.dialog
      .openConfirmDialog(
        `Are you sure you want to delete this Vehicle Category ${data.Vehicle_Category}.`
      )
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult == false) {
          return;
        } else {
          this.showSpinner = true;
          this._LmsService
            .Delete_Lms_VehicleCatMaster({ Int_Id: data.Int_Id })
            .subscribe((res: any) => {
              this.showSpinner = false;
              if (res[0].CODE >= 0) {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: res[0].MSG,
                  ...this.configSuccess,
                });
                this.SelectVehicleCategory = "";
                this.LMS_GetVehicleMaster();
              } else {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: res[0].MSG,
                  ...this.configSuccess,
                });
              }
            });
        }
      });
  }

  editVehicleCat(data: any) {
    console.log("this.areaId", data);
    this.SelectVehicleCategory = data.Vehicle_Category.trim();
    this.Id = data.Int_Id;
    this.Vehicle_Category_Type = data.VCT_Id;
    this.saveBtn = false;
    this.updateBtn = true;
     $("#VehicleCategoryMaster").modal("show");
    $("#VehicleCategoryMaster").css("z-index", "1050");

  }

  UpdateVehicleCategory() {
    this.saveBtn = true;
    this.updateBtn = false;
    let updateDetail = {
      Int_Id: this.Id,
      Vehicle_Category: this.SelectVehicleCategory,
      IsActive: 1,
      Vehicle_Category_Type: this.Vehicle_Category_Type
    };
    this._LmsService
      .Save_Lms_VehicleCategoryMaster(updateDetail)
      .subscribe((response) => {
        if (response[0].CODE == 0) {
          this.Id = 0;
          this.SelectVehicleCategory = "";
          this.LMS_GetVehicleMaster();
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
          this.onclose();
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
        }
      });
  }

  applyFilter(filterValue: string) {
    this.dataCustomerSource.filter = filterValue.trim().toLowerCase();
  }
}
